import { render, staticRenderFns } from "./BasicTriangle.vue?vue&type=template&id=d5977c50&"
import script from "./BasicTriangle.vue?vue&type=script&lang=js&"
export * from "./BasicTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports